import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Logo from '../assets/Logo'
import Languages from './Languages'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
    textDecoration: 'none',
    fontWeight: 300,
    textTransform: 'capitalize',
  },
  menuButton: {
    marginLeft: -12,
  },
  button: {
    marginLeft: 10,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  activeButton: {
    backgroundColor: theme.palette.secondary.selected,
    '&:hover': {
      backgroundColor: theme.palette.secondary.selected,
    },
  },
})

function ButtonAppBar(props) {
  const { handleSetLanguage, language, classes } = props
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" component={Link} to="/">
            <Logo />
          </IconButton>
          <Typography variant="title" color="inherit" className={classes.flex} component={Link} to="/">
            <FormattedMessage id="miniGamesDemo" values={{provider: 'Tazpool'}} />
          </Typography>
          <Languages handleSetLanguage={handleSetLanguage} language={language}/>
          <Button variant="raised" className={classes.button} activeClassName={classes.activeButton} component={NavLink} exact to="/"><FormattedMessage id="embedded" /></Button>
          <Button variant="raised" className={classes.button} activeClassName={classes.activeButton} component={NavLink} to="/on-select"><FormattedMessage id="onSelect" /></Button>
          <Button variant="raised" className={classes.button} activeClassName={classes.activeButton} component={NavLink} to="/on-click"><FormattedMessage id="onClick" /></Button>
        </Toolbar>
      </AppBar>
    </div>
  )
}

ButtonAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(ButtonAppBar)


// WEBPACK FOOTER //
// ./src/components/Menu.js